/**
 * 大数据埋点系统
 **/
import utils from '@/utils/common';
import SHA256 from '@/utils/sha1';

const defaultRouteToNames = route => {
    throw new Error('大数据监控未初始化');
};
const defaultResrouceIdToNames = id => {
    throw new Error('大数据监控未初始化');
};

export class BigDataLog {
    constructor({ appName, appSecrect, baseUrl, tokenUrl }) {
        // window.location 到 names([name1, name2, name3]) 的映射函数
        this.routeToNames = defaultRouteToNames;
        this.resourceIdToNames = defaultResrouceIdToNames;

        this.appName = appName;
        this.appSecrect = appSecrect;
        this.tokenApi = tokenUrl ? tokenUrl + '/api/1.0.1/getToken' : null;
        this.mainApi = baseUrl + '/api/2.0/send_main_message';
        this.detailApi = baseUrl + '/api/2.0/send_detail_message';
        // this.errorApi = baseUrl + '/api/2.0/send_error_message';

        this.moduleName = '';
        this.childModuleName = '';

        this.getUserName = () => '';
        this.token = '';
        this.expire = new Date().getTime();

        this.browserInfo = {};
        this.screenInfo = {};
    }

    init({ moduleName, childModuleName, getUserName, routeToNames, resourceIdToNames }) {
        this.routeToNames = routeToNames;
        this.resourceIdToNames = resourceIdToNames;
        this.getUserName = getUserName;
        this.moduleName = moduleName;
        this.childModuleName = childModuleName;
        this.browserInfo = this.getBrowserInfo();
        this.screenInfo = this.getScreenInfo();
    }

    checkToken() {
        if (!this.token || this.expire < new Date().getTime()) {
            return this.getToken();
        } else {
            return new Promise(resolve => {
                resolve();
            });
        }
    }

    // 获取 token
    getToken() {
        return new Promise((resolve, reject) => {
            if (!this.tokenApi) {
                reject(new Error('tokenApi error'));
            }
            utils.ajax({
                url: this.tokenApi,
                data: {
                    appSecrect: this.appSecrect,
                    appName: this.appName,
                    userName: this.getUserName() // store.state.user.userCode;
                },
                success: data => {
                    data = JSON.parse(data);
                    if (data && data.data) {
                        this.token = data.data.token;
                        this.expire = data.data.expire;
                        resolve();
                    }
                }
            });
        });
    }

    getBrowserInfo() {
        const Sys = {
            platform: window.navigator.platform,
            userAgent: window.navigator.userAgent,
            language: window.navigator.language,
            appPlatform: window.navigator.appVersion,
            appVersion: window.navigator.buildID
        };
        const ua = window.navigator.userAgent.toLowerCase();
        const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        const m = ua.match(re);
        if (m && m[0] && m[1]) {
            Sys.appCodeName = m[1].replace(/version/, "'safari");
            Sys.appName = m[0];
        }
        return Sys;
    }

    getScreenInfo() {
        return {
            availWidth: window.screen.availWidth,
            availHeight: window.screen.availHeight,
            width: window.screen.width,
            height: window.screen.height,
            colorDepth: window.screen.colorDepth,
            pixelDepth: window.screen.pixelDepth
        };
    }

    getNetworkType() {
        let netType = 'wifi';
        if (window.navigator.connection && window.navigator.connection.effectiveType) {
            netType = navigator.connection.effectiveType;
        }
        return netType;
    }

    getMainMessage() {
        return {
            userName: this.getUserName(),
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo
        };
    }

    getDetailMessage(modelInfo = {}) {
        return {
            userName: this.getUserName(),
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo,
            ...modelInfo
        };
    }

    getErrorMessage(errInfo = {}) {
        return {
            userName: this.getUserName(),
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            netType: this.getNetworkType(),
            errContent: errInfo.errContent,
            errType: errInfo.errType
        };
    }

    sendMainMessage() {
        // 必填信息不为空才提交
        if (!this.moduleName) {
            return false;
        }
        this.checkToken().then(() => {
            utils.ajax({
                url: this.mainApi,
                data: {
                    token: this.token,
                    sign: SHA256(this.appName + this.expire + this.appSecrect),
                    appName: this.appName,
                    userName: this.getUserName(),
                    time: this.expire,
                    topicName: 'request_data_main_log',
                    message: JSON.stringify(this.getMainMessage())
                },
                type: 'POST',
                success: function (data) {}
            });
        });
    }

    sendDetailMessage(modelInfo = {}) {
        // 必填信息不为空才提交
        if (!this.moduleName || !modelInfo.model_name1) {
            return false;
        }
        this.checkToken().then(() => {
            utils.ajax({
                url: this.detailApi,
                data: {
                    token: this.token,
                    sign: SHA256(this.appName + this.expire + this.appSecrect),
                    appName: this.appName,
                    userName: this.getUserName(),
                    time: this.expire,
                    topicName: 'request_data_detail_log',
                    message: JSON.stringify(this.getDetailMessage(modelInfo))
                },
                type: 'POST'
            });
        });
    }
}
